export const PulseEventMap = {
  AddToCart: 'add_to_cart',
  RemoveFromCart: 'remove_from_cart',
  ClearCart: 'cart_cleared',
  OrderPlaced: 'order_placed',
  OrderPurshase: 'order_purchase',
  RedirectedToBank: 'redirected_to_bank',
  PhoneClick: 'phone_click',
  EmailClick: 'email_click',
  MapOpened: 'map_opened',
  EventSignUp: 'event_signup',
} as const

export type PulseEvent = ValuesOf<typeof PulseEventMap>

export type PulsePurshasePayload = {
  // идентификатор заказа
  orderId: Id
  // общая сумма заказа
  amount: number
  // валюта
  currency: 'RUB'
  // позиции заказа
  items: {
    // id оффера
    sku: string
    // количество
    qty: number
    // цена
    price: number
  }[]
}
